// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c17614fa","453":"811d9620","455":"c9041313"}[chunkId] + ".chunk.js";
};